<template>
  <Teleport to="body">
    <Modal v-model="modalOpen">
      <ModalContent size="large">
        <template #header>
          <Heading level="h2">{{ t('internal_link_warning.title') }}</Heading>
        </template>

        <div class="tw-flex tw-items-start tw-gap-3">
          <Icon name="warning" class="tw-mt-0.5 tw-size-6 tw-shrink-0 tw-fill-current tw-text-state-warn" />
          <Text>{{ t('internal_link_warning.body') }}</Text>
        </div>

        <template #footer>
          <div class="tw-flex tw-w-full tw-flex-wrap tw-items-center tw-justify-between tw-gap-3">
            <Checkbox v-model="dontWarnAgain" :right-label="t('internal_link_warning.dont_warn')" />

            <div class="tw-flex tw-gap-2">
              <Button color="transparent" outlined @click="cancel">
                {{ t('common.cancel') }}
              </Button>
              <Button color="primary" @click="openAnyway">
                {{ t('internal_link_warning.open_anyway') }}
              </Button>
            </div>
          </div>
        </template>
      </ModalContent>
    </Modal>
  </Teleport>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

import { Button, Checkbox, Heading, Icon, Modal, ModalContent, Text } from '@slideslive/fuse-kit/vue';

import useLinkWarningStore from '@/stores/link_warning';
import useSettingsStore from '@/stores/settings';

const { t } = useI18n();

const linkWarningStore = useLinkWarningStore();
const { open } = storeToRefs(linkWarningStore);

const settingsStore = useSettingsStore();

const dontWarnAgain = ref(false);

// Start each new warning with the box unchecked.
watch(open, (isOpen) => {
  if (isOpen) dontWarnAgain.value = false;
});

// Bridge the store's open state to the Modal's v-model; closing via backdrop/esc cancels.
const modalOpen = computed({
  get: () => open.value,
  set: (value) => {
    if (!value) cancel();
  },
});

function applySuppression() {
  if (dontWarnAgain.value) settingsStore.suppressInternalLinkWarning();
}

function openAnyway() {
  applySuppression();
  linkWarningStore.confirm();
}

function cancel() {
  applySuppression();
  linkWarningStore.cancel();
}
</script>
